/* eslint-disable react/no-multi-comp */
import React from 'react';
import { DocumentoContainer } from '../../components';

const DocumentosTab = () => {
  return <DocumentoContainer headerTitle="Documentos Auxiliares" modulo="NSIR" ativo />;
};

export default DocumentosTab;
